/**
 * @generated SignedSource<<316422ba9855a872fcbfb03d2360db39>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PhoneConfirmMutationInput = {
  clientMutationId?: string | null;
  code: string;
};
export type PhoneEditConfirmChangedMutation$variables = {
  input: PhoneConfirmMutationInput;
};
export type PhoneEditConfirmChangedMutation$data = {
  readonly phoneConfirm: {
    readonly __typename: "Influencer";
    readonly newPhone: string | null;
    readonly phoneNumber: string | null;
  } | {
    readonly __typename: "PhoneConfirmError";
    readonly errorType: string;
    readonly message: string;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  };
};
export type PhoneEditConfirmChangedMutation = {
  response: PhoneEditConfirmChangedMutation$data;
  variables: PhoneEditConfirmChangedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "newPhone",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "phoneNumber",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "errorType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "PhoneConfirmError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PhoneEditConfirmChangedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "phoneConfirm",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/)
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PhoneEditConfirmChangedMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "phoneConfirm",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "512cd2cfa661ec2e515ee39456e38839",
    "id": null,
    "metadata": {},
    "name": "PhoneEditConfirmChangedMutation",
    "operationKind": "mutation",
    "text": "mutation PhoneEditConfirmChangedMutation(\n  $input: PhoneConfirmMutationInput!\n) {\n  phoneConfirm(input: $input) {\n    __typename\n    ... on Influencer {\n      newPhone\n      phoneNumber\n      id\n    }\n    ... on PhoneConfirmError {\n      errorType\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "13fa0f3e8570f9997669795cf1743c4e";

export default node;
